module.exports = __webpack_public_path__ + "static/media/report.5339dedb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screens/report.gif
// module id = 703
// module chunks = 0